import { typography } from '@dentalux/ui-library-core/themes'

import { styled } from '@mui/material'
import Box from '@mui/material/Box'

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
}))

export const IconWrapper = styled('div')(({ theme }) => ({
  color: theme.palette.primary[300],
  marginRight: theme.spacing(2),
  marginTop: 3,
}))

export const Text = styled(Box)({
  ...typography['Sarabun Body 2'],
})
